import http from '../utils/http';

import {
  chunkArray,
} from '../utils/utils';

import {
  GET_LOGS,
  GET_TOTAL_LOGS,
  CLEAR_LOGS,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';

import {
  logsUrl,
} from '../constants/urls';

const getLogsAction = logs => ({
  type: GET_LOGS,
  payload: logs,
});

const getTotalLogs = total => ({
  type: GET_TOTAL_LOGS,
  payload: total,
});

const clearLogsAction = () => ({ type: CLEAR_LOGS });

export const getLogs = (jobId, limit) =>
  async dispatch => {
    try {
      const { data: response } = await http.get(logsUrl(jobId));
      const logs = response.data || [];
      const chunkedLogs = logs.length ? chunkArray(limit)(logs) : [];
      const total = response.data ? response.data.length : 0;

      dispatch(getLogsAction(chunkedLogs));
      dispatch(getTotalLogs(total));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const clearLogs = () => dispatch => dispatch(clearLogsAction())



// WEBPACK FOOTER //
// ./src/actions/logs.js